import { http } from "../client";
export var deletePlaylist = function (id) {
    return http.api
        .delete("playlists/".concat(id))
        .then(function (response) { return ({ id: response.data.playlist_id }); });
};
